import {
  GET_BAZAAR_INTEREST_LIST_REQUEST,
  GET_BAZAAR_INTEREST_LIST_SUCCESS,
  GET_BAZAAR_INTEREST_LIST_FAILURE,
  GET_BAZAAR_INTEREST_LIST_RESET,
} from '../../../types/pvs'

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const getBazaarInterestListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BAZAAR_INTEREST_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case GET_BAZAAR_INTEREST_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Fetched interest list successfully",
      }

    case GET_BAZAAR_INTEREST_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to fetch interest list",
      }

    case GET_BAZAAR_INTEREST_LIST_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default getBazaarInterestListReducer
